import { Link } from "react-router-dom";
import api from "../../../services/api";
import { useEffect, useState } from "react";

function DashboardMain() {
  const [permissions, setPermissions] = useState([]);
  useEffect(() => {
    fetchPermissions();
  }, []);

  const fetchPermissions = async () => {
    try {
      const res = await api.get("/users/permissions");
      setPermissions(res.data.data);
    } catch (error) {}
  };
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {permissions && permissions.includes("blogs.view") && (
          <Link
            to="/blogs"
            className="bg-white rounded-2xl shadow-md hover:shadow-xl transition p-8 text-center text-lg font-semibold text-gray-700 hover:bg-blue-50"
          >
            📝 Quản lý blog
          </Link>
        )}

        {permissions && permissions.includes("users.view") && (
          <Link
            to="/users"
            className="bg-white rounded-2xl shadow-md hover:shadow-xl transition p-8 text-center text-lg font-semibold text-gray-700 hover:bg-blue-50"
          >
            👤 Quản lý người dùng quản trị
          </Link>
        )}
      </div>
    </div>
  );
}

export default DashboardMain;
